(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["two-column-accordion"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.two-column-accordion__accordion-items h3').click(function () {
     $(this).toggleClass('active');
  
     var targetAcordion = $(this).next();
     var getActualHeight = targetAcordion.prop('scrollHeight');
  
     if ($(this).hasClass('active')) {
      targetAcordion.css('max-height', getActualHeight);
     } else {
      targetAcordion.css('max-height', 0);
     }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
